export interface ChartColors {
  background: string;
  text: string;
  grid: string;
  border: string;
  upColor: string;
  downColor: string;
  volUp: string;
  volDown: string;
}

/**
 * Paleta de colores del chart según tema. Extraído de grafica-modelo
 * (era un método privado `getChartColors()`) para que multicharts-dialog
 * use exactamente los mismos valores.
 */
export function getChartColors(isDark: boolean): ChartColors {
  return {
    background: isDark ? '#1e222d' : '#ffffff',
    text: isDark ? '#d1d4dc' : '#000000',
    grid: isDark ? '#2a2e39' : '#e6e6e6',
    border: isDark ? '#3a3f4b' : '#ccd6eb',
    upColor: isDark ? '#26a69a' : '#26a69a',
    downColor: isDark ? '#ef5350' : '#ef5350',
    volUp: isDark ? '#26a69a' : '#26a69a',
    volDown: isDark ? '#ef5350' : '#ef5350',
  };
}
